/**
 * Enums for supported announcement tags
 *
 * Copyright (c) 2023 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
export const PRODUCT = {
  id: 'product',
  title: 'Announcement',
  color: 'success'
}

export const WHATS_NEW = {
  id: 'whats-new',
  title: 'What\'s New',
  color: 'info'
}
